import { Button, Grid2 } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import IAEauAction from '../../../../iaeau/IAEauAction'
import useParseJson from '../../../../utils/customHook/useParseJson'
import { STATION_TYPE_NAME } from '../../../constants/StationConstants'

const HydratecModes = {
    CRUE_INI: 'CRUE_INI',
    CRUE: 'CRUE',
    ACTU: 'ACTU',
}

const HydratecParamsPanel = ({
    model = {},
    id,
    onChangeJob = () => {},
    onExecute = () => {},
}) => {
    // const dispatch = useDispatch()
    const { json: modelParams } = useParseJson(model.params)

    // const {
    //     jobs,
    // } = useSelector(store => ({
    //     jobs: store.JobReducer.jobs.filter(j => j.jobType.startsWith('modelCalculationManually') && j.id > 0),
    // }), shallowEqual)

    const changeMode = (mode) => {
        // const job = jobs.find(j => j.id === model.jobId)
        onChangeJob({ cron: mode === HydratecModes.CRUE_INI ? '0 0 * * * * *' : '0 0 8 * * * *' }, () => {
            const newModel = { ...model, statusCode: 7, params: JSON.stringify({ ...modelParams, mode }) }
            IAEauAction.updateModel(STATION_TYPE_NAME.hydrometry, id, newModel).then(() => {
                onExecute()
                // dispatch(IAEauAction.getModels(STATION_TYPE_NAME.hydrometry, id)).then(() => {
                //     IAEauAction.launchModel(STATION_TYPE_NAME.hydrometry, id, newModel).then(() => {
                //         dispatch(push(`/station/hydrometry/${id}/iaeauModels`))
                //     })
                // })
            })
        })
    }
    return (
        <Grid2 container alignItems='center'>
            <Grid2 size={2}>
                Mode actuel : {modelParams.mode}
            </Grid2>
            <Grid2 size={2}>
                <Button variant='contained' color='primary' disabled={modelParams.mode === HydratecModes.CRUE} onClick={() => changeMode(HydratecModes.CRUE_INI)}>Passer en mode CRUE</Button>
            </Grid2>
            <Grid2 size={2}>
                <Button variant='contained' color='primary' disabled={modelParams.mode === HydratecModes.ACTU} onClick={() => changeMode(HydratecModes.ACTU)}>Stopper le mode CRUE</Button>
            </Grid2>
        </Grid2>
    )
}

HydratecParamsPanel.propTypes = {
    id: PropTypes.string,
    model: PropTypes.shape({}),
    onExecute: PropTypes.func,
    onChangeJob: PropTypes.func,
}

export default HydratecParamsPanel